module.exports = __webpack_public_path__ + "img/user-name.fa62b268.png";